// import PropTypes from "prop-types";
// import { Link as RouterLink } from "react-router-dom";
// import useGetLogo from "./hooks/use-logo";

// const Logo = ({ disabledLink = false }) => {
//   const logo = useGetLogo();

//   if (disabledLink) {
//     return (
//       <img
//         style={{ width: "100px", height: "auto", maxHeight: "64px" }}
//         src={logo}
//       />
//     );
//   }

//   return (
//     <RouterLink to="/">
//       <img style={{ width: "100px", height: "auto" }} src={logo} />
//     </RouterLink>
//   );
// };

// Logo.propTypes = {
//   disabledLink: PropTypes.bool,
//   sx: PropTypes.object,
// };

// export default Logo;

import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { Box, useTheme } from "@mui/material";
import useGetLogo from "./hooks/use-logo";

const Logo = ({ disabledLink = false, sx }) => {
  const logo = useGetLogo();
  // const logo =  "/logo/LogoIm--1762617901.png"
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  if (!logo) {
    return null; // or <Box sx={{ width: 100, height: 64 }} />
  }

  const logoElement = (
    <Box
      component="img"
      src={logo}
      alt=""
      sx={{
        width: "100px",
        height: "auto",
        maxHeight: "64px",

        // Light Mode: White text → Black
        // Dark Mode: White text → White
        filter: isDarkMode
          ? "none"
          : "invert(1) hue-rotate(180deg)",

        transition: "filter 0.3s ease",
        ...sx,
      }}
    />
  );

  if (disabledLink) return logoElement;

  return <RouterLink to="/">{logoElement}</RouterLink>;
};

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;